// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JONF","title":"styles_title__Muxm6"};